import React from "react";
import backgroundImage from "../../images/logo/logo_hydreaulys_bd.png";
export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <>
      <a href={"/"}>
        <img
          className={`${className} w-24`}
          src={backgroundImage}
          alt="LogoImg"
        />
      </a>
    </>
  );
};

export default Logo;
